import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const BlastEvent = (props) => {
  const data = useStaticQuery(graphql`
    query {
      blastEvent: file(
        relativePath: {
          eq: "components/pages/HiringPage/Sections/GallerySection/images/blast-event.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 834, maxHeight: 538, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.blastEvent.childImageSharp.fluid} {...props} />
}

export default BlastEvent
